import { IMessage, IMessages } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const setMessages = createAction('[Messages] Set messages', props<{ value: IMessages }>());
export const addMessage = createAction('[Messages] Add message', props<{ value: IMessage }>());
export const delMessage = createAction('[Messages] Del message', props<{ value: string }>());
export const delMessages = createAction('[Messages] Del messages');
